<template lang="pug">
.modal-confirmacao
    .linha
        b.coluna {{"Esta ação pode causar a perda de dados não salvos. Realmente deseja prosseguir?"}}
    .linha
        .coluna
            .modal-footer(:style='[ { display: "flex" },  { justifyContent: "space-between" }, { marginTop: "30px" } ]')
                button-component(
                    label='Cancelar',
                    icon='mdi-close',
                    background-color='var(--primary-gray)',
                    color='var(--primary-light-smoke)',
                    @click.native='$emit("confirmacao", false)'
                )
                button-component(label='Prosseguir', @click.native='$emit("confirmacao", true)')
</template>

<script>
export default {

    name: 'ModalConfirmacaoEtapas',

    props: {
    },

    data() {
        return {
        }
    }
}
</script>

<style lang="scss"></style>
